/**
 * Part 4 — Environment Validation Utility
 *
 * Call validateEnv() inside App on mount (useEffect), NOT at module scope.
 * This ensures environment issues are logged as warnings without
 * crashing the module graph.
 */

export function validateEnv() {
    const warnings = [];

    if (!import.meta.env.VITE_API_URL) {
        warnings.push(
            'VITE_API_URL is not set. API calls will use same-origin. ' +
            'Set this in your environment if the backend is on a different domain.'
        );
    }

    if (import.meta.env.DEV) {
        console.info('[Saige] Running in development mode');
    }

    warnings.forEach(w => console.warn(`[Saige] ENV: ${w}`));

    return { valid: warnings.length === 0, warnings };
}
